import { UXComponent } from './component.js';
const Navbar = () => {
    return new UXComponent({ visible: true });
};
export default Navbar;
//# sourceMappingURL=navbar.js.map